import React from 'react'
import SelectDropdown from '../atomic/SelectDropdown'
import { optionsRuolo } from './utils'

const Forms = ({ formik, articolo = false }) => {
  const getActiveClass = name => {
    return formik.values[name] ? 'valid' : ''
  }
  const getFieldClass = field => {
    return formik.errors[field] ? 'error' : formik.values[field] !== '' ? 'valid' : ''
  }

  return (
    <>
      <div className="row">
        <div className="col-12 ruolo-container">
          <p className="ruolo-container__text">Sono un</p>
          <div className="ruolo-container__div-dropdown">
            <div className="w-form__field-wrapper">
              <SelectDropdown
                instanceId={`ruolo`}
                placeholder={''}
                options={optionsRuolo}
                onChange={formik.handleChange}
                value={formik.values.ruolo}
                classes={getActiveClass('ruolo')}
              />
              <label htmlFor="ruolo">Il tuo ruolo*</label>
              <span className="w-form__error">{formik.errors.nome}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="w-form__field-wrapper">
            <input
              type="text"
              className={getFieldClass('nome')}
              id="nome"
              name="nome"
              value={formik.values.nome}
              onChange={formik.handleChange}
            />
            <label htmlFor="nome">Nome*</label>
            <span className="w-form__error">{formik.errors.nome}</span>
          </div>
        </div>
        <div className="col-md-6">
          <div className="w-form__field-wrapper">
            <input
              type="text"
              className={getFieldClass('cognome')}
              id="cognome"
              name="cognome"
              value={formik.values.cognome}
              onChange={formik.handleChange}
            />
            <label htmlFor="cognome">Cognome*</label>
            <span className="w-form__error">{formik.errors.cognome}</span>
          </div>
        </div>
        <div className="col-md-6">
          <div className="w-form__field-wrapper">
            <input
              type="email"
              id="email"
              name="email"
              className={getFieldClass('email')}
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            <label htmlFor="email">Email*</label>
            <span className="w-form__error">{formik.errors.email}</span>
          </div>
        </div>
        <div className="col-md-6">
          <div className="w-form__field-wrapper">
            <input
              // pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
              type="tel"
              id="telefono"
              name="telefono"
              className={getFieldClass('telefono')}
              value={formik.values.telefono}
              onChange={formik.handleChange}
            />
            <label htmlFor="telefono">Telefono</label>
          </div>
        </div>
        {articolo ? (
          <>
            <div className="col-12">
              <div className="w-form__field-wrapper">
                <input
                  type="text"
                  id="titolo"
                  name="titolo"
                  className={getFieldClass('titolo')}
                  value={formik.values.titolo}
                  onChange={formik.handleChange}
                />
                <label htmlFor="titolo">Titolo*</label>
                <span className="w-form__error">{formik.errors.titolo}</span>
              </div>
            </div>
          </>
        ) : (
          <div className="col-12">
            <div className="w-form__field-wrapper">
              <textarea
                rows="4"
                cols="50"
                id="richiesta"
                name="richiesta"
                className={getFieldClass('richiesta')}
                value={formik.values.richiesta}
                onChange={formik.handleChange}
              />
              <label htmlFor="richiesta">Richiesta</label>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default Forms
